<div class="row vh-100 align-items-center">
  <div class="col-6 offset-3 text-center">
    <img src="/assets/img/svgs/undraw_page_not_found_su7k.svg" width="60%"/>
    <h1 class="display-4 lead mt-5"><i class="fas fa-exclamation-triangle text-warning"></i> Ooops! La pagina che stavi
      cercando non esiste.</h1>
    <p class="lead">Puoi tornare alla home <a [routerLink]="['/']">cliccando qui</a> o cliccando su una sezione del menu a sinistra.</p>
  </div>
</div>
